import BASIC from "./basic";

export default {
  ...BASIC,
  background: 'rgb(255, 196, 250)',
  color: 'white',
};
